module.exports = __webpack_public_path__ + "static/gallery3-82066dd59a47f45e1cc3fc922f25ac0e.jpeg";